import classNames from 'classnames';
import { FC, SVGProps } from 'react';

import { CoreGlobalNavigationFooterData } from 'src/types/components';

import FacebookIcon from 'assets/icons/facebook.svg';
import InstagramIcon from 'assets/icons/instagram.svg';
import LinkedInIcon from 'assets/icons/linkedin.svg';
import XIcon from 'assets/icons/x.svg';
import YouTubeIcon from 'assets/icons/youtube.svg';

import Link from 'components/BaseHelpers/Link';

import styles from './SocialLinks.module.scss';

export type SocialLinksProps = {
  className?: string;
  links: CoreGlobalNavigationFooterData['fields']['socialMediaLinks'];
};

const IconMap: Record<string, FC<SVGProps<SVGSVGElement>>> = {
  linkedin: LinkedInIcon,
  x: XIcon,
  youtube: YouTubeIcon,
  facebook: FacebookIcon,
  instagram: InstagramIcon,
};

const getIcon = (name: string) => {
  if (!name) {
    throw Error(`icon ${name} not defined`);
  }

  const Icon = IconMap[name];
  return <Icon width={20} height={20} className={styles.icon} />;
};

const SocialLinks = ({ links, className }: SocialLinksProps) => {
  if (links.length === 0) return null;

  return (
    <ul className={classNames(styles.list, className)} aria-label="Social Links">
      {links.map(({ url, platform }, index) => {
        return (
          <li key={index} className={styles.item}>
            <Link
              aria-label={`Visit our ${platform} page.`}
              href={url}
              target="_blank"
              className={styles.link}
            >
              {getIcon(platform)}
            </Link>
          </li>
        );
      })}
    </ul>
  );
};

export default SocialLinks;
